import React, {createContext} from "react";

const GoogleMapsAPIContextProvider = createContext({
  places: undefined
});

export default GoogleMapsAPIContextProvider;

